<template>
  <div class="event-guest">
    <event-detail-title :type="anchorMap.GUESTS_KEY"></event-detail-title>
    <div v-if="guests">
      <div class="guest-container" v-for="(item, id) in guests" :key="id">
        <div class="guest-card">
          <div class="guest-pic">
            <img :src="item.image || 'https://static001-test.geekbang.org/resource/image/c6/73/c69567ba5548b70b991abf2dd5ca7f73.png'">
          </div>
          <div class="guest-info">
            <div class="guest-name">{{item.name}}</div>
            <div class="guest-title">{{item.position}}</div>
          </div>
        </div>
        <div class="section-content guest-profile">{{item.personal_profile}}</div>
        <div class="guest-share-title-container" v-if="item.theme">
          <span class="guest-share-title" v-if="item.theme">分享主题：</span>
          <span class="guest-share-content">{{item.theme}}</span>
        </div>
        <div class="section-content guest-share-profile">{{item.content_profile}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import vueTypes from 'vue-types'
import eventDetailTitle from './event-detail-title'
import { anchorMap } from './utils'
export default {
  name: 'event-detail-guest',
  data () {
    return {
      anchorMap
    }
  },
  components: {
    eventDetailTitle
  },
  props: {
    guests: vueTypes.array.isRequired
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/bulma/app.sass';
.section-content{
  line-height: 32px;
  color: #4A4A4A;
}
.event-guest {
  margin-bottom: 10px;
  .guest-container {
    padding: 20px 0;
    border-bottom: 1px solid rgba(215, 179, 117, .4);

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        border: none;
      }

    .guest-card {
      display: flex;
      align-items: center;
      .guest-pic {
        margin-right: 22px;
        width: 77px;
        height: 77px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        img {
          position: absolute;
          width: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .guest-info {
        .guest-name {
          font-size: 20px;
          line-height: 22px;
          // height: 20px
          font-weight: 600;
          color: #353535;
          margin-bottom: 5px;
          // +limit-line-numbers(1)
        }

        .guest-title {
          font-size: 16px;
          color: #9a9a9a;
          // +limit-line-numbers(1)
        }
      }
    }

    .guest-share-title-container {
        margin: 14px 0 4px;
        font-weight: 600;
        .guest-share-title {
          position: relative;
          padding-left: 8px;

          &::after {
            position: absolute;
            content: '';
            left: 0;
            top: 14%;
            height: 72%;
            width: 2px;
            background-color: $primary3;
          }
        }
    }

  }
}
</style>
